import { NOTIFICATIONS } from "../config";
import { get, post } from "./apiHelper";

export const fetchNotifications = () => get(NOTIFICATIONS, { noCache: true });

export const fetchNotificationUnreadCount = () =>
  get(`${NOTIFICATIONS}/unread-count`, { noCache: true });

export const markNotificationRead = (id) => post(`${NOTIFICATIONS}/${id}/read`);

export const markNotificationUnread = (id) =>
  post(`${NOTIFICATIONS}/${id}/unread`);

export const markAllNotificationsRead = () => post(`${NOTIFICATIONS}/read-all`);

export const deleteNotification = (id) => post(`${NOTIFICATIONS}/delete/${id}`);

export const clearNotifications = () => post(`${NOTIFICATIONS}/clear`);
